import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps, withTypography } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';

export const InformationTitle = withTypography({
  variant: 'headerFour',
  fontSize: 'md',
  lineHeight: 'lg',
});

export const NutritionInformationWrapper = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Box
      {...props}
      style={[
        styles.nutritionInformationWrapper,
        isDesktop && styles.nutritionInformationWrapperDesktop,
        style,
      ]}
    />
  );
};

export const NutritionInformationContainer = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Box
      {...props}
      style={[
        styles.nutritionInformationContainer,
        isDesktop && styles.nutritionInformationContainerDesktop,
        style,
      ]}
    />
  );
};

const styles = StyleSheet.create({
  nutritionInformationContainer: {
    marginVertical: 8,
  },
  nutritionInformationContainerDesktop: {
    marginVertical: 24,
  },
  nutritionInformationWrapper: {
    paddingHorizontal: 16,
  },
  nutritionInformationWrapperDesktop: {
    paddingHorizontal: 0,
  },
});
